import React from "react";

const Logo = ({ onClick, dark = false }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <img
        src="/newcover_logo.png"
        alt="NewCover Ltd Logo"
        style={{
          height: 44,
          objectFit: "contain",
        }}
      />
    </div>
  );
};

export default Logo;